<template>
  <div class="order-management">
    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单编号">
          <el-input
              v-model="filterForm.orderNo"
              placeholder="请输入订单编号"
              clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="客户名称">
          <el-input
              v-model="filterForm.customerName"
              placeholder="请输入客户名称"
              clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="订单状态">
          <el-select
              v-model="filterForm.status"
              placeholder="请选择状态"
              clearable
          >
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="下单时间">
          <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="operation-container">
      <el-button type="primary" @click="handleCreate">
        <i class="el-icon-plus"></i> 新建订单
      </el-button>
      <el-button type="success" @click="handleExport">
        <i class="el-icon-download"></i> 导出
      </el-button>
      <el-button type="info" @click="handleImport">
        <i class="el-icon-upload2"></i> 导入
      </el-button>
    </div>

    <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="orderNo" label="订单编号" width="180"></el-table-column>
      <el-table-column prop="customerName" label="客户名称" width="120"></el-table-column>
      <el-table-column prop="productName" label="产品名称"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
      <el-table-column prop="amount" label="金额(元)" width="120" align="right">
        <template slot-scope="scope">
          {{ scope.row.amount.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="下单时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container" v-show="!loading">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
      ></el-pagination>
    </div>

    <!-- 导入对话框 -->
    <el-dialog title="导入订单" :visible.sync="importDialogVisible" width="500px">
      <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleImportSuccess"
          :before-upload="beforeImportUpload"
          :show-file-list="false"
          accept=".xlsx, .xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过5MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmImport">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 订单编辑/新增对话框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="600px"
        @close="resetForm"
    >
      <el-form :model="orderForm" :rules="rules" ref="orderForm" label-width="100px">
        <el-form-item label="订单编号" prop="orderNo">
          <el-input v-model="orderForm.orderNo"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName">
          <el-input v-model="orderForm.customerName"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="productName">
          <el-input v-model="orderForm.productName"></el-input>
        </el-form-item>
        <el-form-item label="数量" prop="quantity">
          <el-input-number v-model="orderForm.quantity" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="单价(元)" prop="unitPrice">
          <el-input-number v-model="orderForm.unitPrice" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="金额(元)" prop="amount">
          <el-input v-model="orderForm.amount" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="orderForm.status" placeholder="请选择状态">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportJsonToExcel } from '@/utils/export2Excel'

export default {
  name: 'OrderManagement',
  data() {
    return {
      filterForm: {
        orderNo: '',
        customerName: '',
        status: '',
        dateRange: []
      },
      statusOptions: [
        { value: '1', label: '待付款' },
        { value: '2', label: '已付款' },
        { value: '3', label: '已发货' },
        { value: '4', label: '已完成' },
        { value: '5', label: '已取消' }
      ],
      tableData: [],
      multipleSelection: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      importDialogVisible: false,
      dialogVisible: false,
      dialogTitle: '新增订单',
      orderForm: {
        id: '',
        orderNo: '',
        customerName: '',
        productName: '',
        quantity: 1,
        unitPrice: 0,
        amount: 0,
        status: '1',
        createTime: ''
      },
      rules: {
        orderNo: [
          { required: true, message: '请输入订单编号', trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        unitPrice: [
          { required: true, message: '请输入单价', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      isEdit: false
    }
  },
  watch: {
    'orderForm.quantity'() {
      this.calculateAmount()
    },
    'orderForm.unitPrice'() {
      this.calculateAmount()
    }
  },
  created() {
    this.getOrderList()
  },
  methods: {
    // 获取订单列表（模拟数据）
    getOrderList() {
      this.loading = true
      // 模拟API请求延迟
      setTimeout(() => {
        // 生成模拟数据
        const mockData = this.generateMockData(85)

        // 模拟筛选
        let filteredData = [...mockData]
        if (this.filterForm.orderNo) {
          filteredData = filteredData.filter(item =>
              item.orderNo.includes(this.filterForm.orderNo))
        }
        if (this.filterForm.customerName) {
          filteredData = filteredData.filter(item =>
              item.customerName.includes(this.filterForm.customerName))
        }
        if (this.filterForm.status) {
          filteredData = filteredData.filter(item =>
              item.status === this.filterForm.status)
        }
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          const [start, end] = this.filterForm.dateRange
          filteredData = filteredData.filter(item => {
            const createTime = new Date(item.createTime).getTime()
            const startTime = new Date(start).getTime()
            const endTime = new Date(end).getTime()
            return createTime >= startTime && createTime <= endTime
          })
        }

        // 模拟分页
        const total = filteredData.length
        const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
        const end = start + this.pagination.pageSize
        this.tableData = filteredData.slice(start, end)
        this.pagination.total = total

        this.loading = false
      }, 500)
    },

    // 生成模拟数据
    generateMockData(count) {
      const mockData = []
      const statuses = ['1', '2', '3', '4', '5']
      const products = ['iPhone 13', 'MacBook Pro', 'iPad Air', 'Apple Watch', 'AirPods Pro']
      const customers = ['张三', '李四', '王五', '赵六', '钱七', '孙八', '周九', '吴十']

      for (let i = 1; i <= count; i++) {
        const product = products[Math.floor(Math.random() * products.length)]
        const customer = customers[Math.floor(Math.random() * customers.length)]
        const quantity = Math.floor(Math.random() * 10) + 1
        const unitPrice = Math.floor(Math.random() * 1000) + 500
        const amount = quantity * unitPrice
        const status = statuses[Math.floor(Math.random() * statuses.length)]
        const date = new Date()
        date.setDate(date.getDate() - Math.floor(Math.random() * 30))

        mockData.push({
          id: i,
          orderNo: `ORD${date.getTime().toString().slice(-6)}${i.toString().padStart(4, '0')}`,
          customerName: customer,
          productName: product,
          quantity: quantity,
          unitPrice: unitPrice,
          amount: amount,
          status: status,
          createTime: date.toISOString().split('T')[0] + ' ' +
              date.toTimeString().split(' ')[0]
        })
      }

      return mockData
    },

    // 计算金额
    calculateAmount() {
      this.orderForm.amount = (this.orderForm.quantity * this.orderForm.unitPrice).toFixed(2)
    },

    // 查询
    handleSearch() {
      this.pagination.currentPage = 1
      this.getOrderList()
    },

    // 重置查询条件
    resetFilter() {
      this.filterForm = {
        orderNo: '',
        customerName: '',
        status: '',
        dateRange: []
      }
      this.handleSearch()
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getOrderList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getOrderList()
    },

    // 表格选择项变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 新建订单
    handleCreate() {
      this.dialogTitle = '新增订单'
      this.isEdit = false
      this.dialogVisible = true
    },

    // 编辑订单
    handleEdit(index, row) {
      this.dialogTitle = '编辑订单'
      this.isEdit = true
      this.orderForm = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    // 删除订单
    handleDelete() {
      this.$confirm('确认删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 模拟删除操作
        this.$message.success('删除成功')
        this.getOrderList()
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 提交表单
    submitForm() {
      this.$refs.orderForm.validate(valid => {
        if (valid) {
          // 模拟提交
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.getOrderList()
        } else {
          return false
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.orderForm.resetFields()
      this.orderForm = {
        id: '',
        orderNo: '',
        customerName: '',
        productName: '',
        quantity: 1,
        unitPrice: 0,
        amount: 0,
        status: '1',
        createTime: ''
      }
    },

    // 导出订单
    handleExport() {
      if (this.multipleSelection.length === 0) {
        this.$confirm('未选择任何订单，是否导出全部订单数据?', '提示', {
          confirmButtonText: '导出全部',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportAllOrders()
        })
      } else {
        this.exportSelectedOrders()
      }
    },

    // 导出全部订单
    exportAllOrders() {
      this.loading = true
      // 模拟获取全部数据
      setTimeout(() => {
        const mockData = this.generateMockData(this.pagination.total)
        this.exportExcel(mockData)
        this.loading = false
      }, 500)
    },

    // 导出选中订单
    exportSelectedOrders() {
      this.exportExcel(this.multipleSelection)
    },

    // 执行导出Excel
    exportExcel(data) {
      const tHeader = ['订单编号', '客户名称', '产品名称', '数量', '金额(元)', '状态', '下单时间']
      const filterVal = ['orderNo', 'customerName', 'productName', 'quantity', 'amount', 'status', 'createTime']
      const formatData = data.map(item => {
        return filterVal.map(key => {
          if (key === 'status') {
            return this.getStatusText(item[key])
          }
          return item[key]
        })
      })

      exportJsonToExcel({
        header: tHeader,
        data: formatData,
        filename: '订单数据',
        autoWidth: true,
        bookType: 'xlsx'
      })
    },

    // 导入订单
    handleImport() {
      this.importDialogVisible = true
    },

    // 上传前校验
    beforeImportUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过5MB!')
        return false
      }
      return true
    },

    // 导入成功
    handleImportSuccess() {
      // 这里应该是解析Excel文件的逻辑
      // 模拟解析成功
      this.$message.success('文件上传成功')
      // 实际项目中这里应该解析Excel文件内容
    },

    // 确认导入
    confirmImport() {
      // 模拟导入操作
      this.$message.success('导入成功')
      this.importDialogVisible = false
      this.getOrderList()
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        '1': '待付款',
        '2': '已付款',
        '3': '已发货',
        '4': '已完成',
        '5': '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        '1': 'warning',
        '2': '',
        '3': 'info',
        '4': 'success',
        '5': 'danger'
      }
      return typeMap[status] || ''
    }
  }
}
</script>

<style scoped>
.order-management {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.operation-container {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
  padding: 10px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.upload-demo {
  text-align: center;
}

@media (max-width: 768px) {
  .filter-form {
    display: flex;
    flex-direction: column;
  }

  .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>